export default __webpack_public_path__ + "static/media/ResetLinkSent.a984be4a.svg";